import taskApi from '@/api/task'

const state = () => ({
  all: [],
  types: [],
  task: {}
})

const getters = {}

const actions = {
  async getTasks ({ commit }, params) {
    const result = await taskApi.getAll(params)
    commit('setTasks', result.data)
    return result
  },

  async getTask ({ commit }, id) {
    const result = await taskApi.getOne(id)
    commit('setTask', result.data)
  },

  async force ({ commit }, id) {
    const result = await taskApi.force(id)
    commit('setTask', result.data)
  },

  async rerun ({ commit }, id) {
    const result = await taskApi.rerun(id)
    commit('setTask', result.data)
  },

  async cancel ({ commit }, id) {
    const result = await taskApi.cancel(id)
    commit('setTask', result.data)
  },

  async getTypes ({ commit }) {
    const result = await taskApi.getTypes()
    commit('setTasksTypes', result.data)
  },

  async kill ({ commit }, id) {
    const result = await taskApi.kill(id)
    commit('setTask', result.data)
  },

  async forceResume ({ commit }, id) {
    const result = await taskApi.forceResume(id)
    commit('setTask', result.data)
  },
}

const mutations = {
  setTask (state, task) {
    state.task = task
  },
  setTasks (state, tasks) {
    state.all = tasks
  },
  setTasksTypes (state, types) {
    state.types = types
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
